// REGISTRATION FORM

jQuery(document).ready(function ($) {

  $('.c-btn__lookupaccount, .c-registration-form__backtocontacts-link').click(function () {
    $('.c-registration-form__checkbox-container').removeClass("hide");
    $('.c-registration-form__choose-contact').addClass("active");
    $('.c-registration-form__backtocontacts-container').removeClass("active");
    $('.c-registration-form__register-complete').removeClass("active");
  });

  // LOOK UP CONTACT
  $('.c-registration-form__lookup-account').click(function () {
    $('.c-registration-form__register-new-contact').addClass("active");
    $('.c-registration-form__choose-contact').removeClass("active");
  });

  // CHOOSE CONTACT
  $('.c-registration-form__choose-contact-btn').click(function () {
    $('.c-registration-form__register-complete').addClass("active");
    $('.c-registration-form__choose-contact').removeClass("active");
    $('.c-registration-form__create-account').removeClass("active");
    $('.c-registration-form__checkbox-container').addClass("hide");
    $('.c-registration-form__backtocontacts-container').addClass("active");
  });

  // DON'T HAVE AN ACCOUNT
  $('.c-registration-form__checkbox').change(function () {
    if ($(this).is(":checked")) {
      $('.c-account-number, .c-account-zip, .c-btn__lookupaccount').prop("disabled", true);
      $('.c-account-number, .c-account-zip, .c-btn__lookupaccount').addClass("disable");
      $('.c-registration-form__create-account').addClass("active");
      $('.c-registration-form__choose-contact').removeClass("active");
    } else {
      $('.c-account-number, .c-account-zip, .c-btn__lookupaccount').prop("disabled", false);
      $('.c-account-number, .c-account-zip, .c-btn__lookupaccount').removeClass("disable");
      $('.c-registration-form__create-account').removeClass("active");
    }
  });

  // SHIP TO ADDRESS

  $('#shipto').change(function () {
    if ($(this).is(":checked")) {
      $('.shipto-form').hide();
    } else {
      $('.shipto-form').show();
    }
  });

  // REGISTER NEW CONTACT
  $('.c-registration-form__choose-contact-register').click(function () {
    $('.c-registration-form__register-new-contact').addClass("active");
    $('.c-registration-form__create-account').removeClass("active");
    $('.c-registration-form__choose-contact').removeClass("active");
    $('.c-registration-form__checkbox-container').addClass("hide");
  })

  //SUCCESS
  $('.c-registration-form__register-success-btn').click(function () {
    $('.c-registration-form__success').addClass("active");
    $('.c-registration-form__register-complete').removeClass("active");
    $('.c-registration-form__create-account').removeClass("active");
    $('.c-registration-form__choose-contact').removeClass("active");
    $('.c-registration-form__checkbox-container').addClass("hide");
    $('.c-registration-form').addClass("hide");
  })

});

